import React from "react";
import {View, StyleSheet} from "react-native";
import {FontAwesome} from "@expo/vector-icons";
import AddTaskButton from "./AddTaskButton";
import {AsyncDispatch} from "../function/functions";
import {useDispatch} from "react-redux";
import {useTheme} from "@react-navigation/native";
import {useTranslation} from "react-i18next";

export const MainMenu = (props) => {
    const navigation = props.navigation;
    const {t, i18n} = useTranslation();
    const theme = useTheme();
    const dispatch = useDispatch();
    const styles = StyleSheet.create({
        buttonWrapper: {
            display:'flex',
            flexDirection:'row',
            flexWrap:'nowrap',
            alignItems:'center',
            justifyContent:'center',
            marginTop: 8,
            marginBottom:128,
            width: '100%',
            height:64
        },
        mainButtonFontSize: {
            fontSize:20
        }
    })
    return(
        <View style={styles.buttonWrapper}>
            <View>
                <AddTaskButton
                    title={<FontAwesome style={{fontSize:32, color:theme.colors.scheme[4]}} name={'plus'} />}
                    onPress={() => {
                        //scrollViewRef.current.scrollToEnd({ animated: true });
                        let id = new Date().getTime();
                        AsyncDispatch(dispatch,"ADD_TASK", {[id]: {id:id, text: '', complete:false}}).then(() => {
                            dispatch({type: 'SAVE_TASK', payload:[]});
                            navigation.navigate('Home');
                        })
                    }} />
            </View>
        </View>
    )
}